import styled from "styled-components";
import CurrencyInput from "react-currency-input-field";

export const Container = styled.div`
  padding: 2rem;
  max-width: 800px;
  margin: auto;
`;

export const Header = styled.h2`
  text-align: center;
  margin-bottom: 2rem;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-bottom: 2rem;
`;

export const Label = styled.label`
  font-weight: bold;
`;

export const Input = styled.input`
  padding: 0.5rem;
  border: 1px solid #ccc;
`;

export const InputGroup = styled.div`
  display: flex;
  gap: 1rem;
  margin-top: 1rem;
  flex-wrap: wrap;
  justify-content: space-between;
`;

export const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%; 
  max-width: 200px;
`;

export const Select = styled.select`
  padding: 0.5rem;
  border: 1px solid #ccc;
  border-radius: 4px;
`;

export const Textarea = styled.textarea`
  padding: 0.5rem;
  border: 1px solid #ccc;
  height: 300px;
`;

export const ImovelCard = styled.div`
  border: 1px solid #ddd;
  padding: 1rem;
  margin-bottom: 1rem;
`;

export const CardActions = styled.div`
  display: flex;
  gap: 1rem;
  margin-top: 0.5rem;
`;

export const ImageSlider = styled.div`
  display: flex;
  overflow-x: auto;
  padding: 0.5rem 0;
  gap: 1rem;
`;

export const ImageWrapper = styled.div`
  text-align: center;
  flex: 0 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const PreviewImage = styled.img`
  width: 150px;
  height: 150px;
  object-fit: cover;
  border-radius: 4px;
`;

export const ImageControls = styled.div`
  margin-top: 0.5rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  align-items: center;
`;

export const SectionTitle = styled.p`
  font-weight: bold;
  margin-top: 1rem;
`;

export const ErrorMessage = styled.p`
  color: red;
`;

export const RadioWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem; /* espaço entre o radio e o label */
`;

export const InputMonetario = styled(CurrencyInput)`
  width: 100%;
  padding: 8px 12px;
  font-size: 16px;
  border: 1px solid #ccc;
  border-radius: 4px;

  &:focus {
    border-color: #007bff;
  }
`;
